var map = {
	"./activearrow.svg": 122,
	"./attach.svg": 282,
	"./back.svg": 50,
	"./calendar.svg": 342,
	"./chat.svg": 137,
	"./close.svg": 64,
	"./delete.svg": 1012,
	"./edit.svg": 353,
	"./favactive.svg": 1013,
	"./image.svg": 1014,
	"./incorrect.svg": 510,
	"./leftarrowbg.svg": 1015,
	"./leftarrowbgs.svg": 1016,
	"./location.svg": 98,
	"./more.svg": 68,
	"./peoplelocation.svg": 350,
	"./premium.svg": 354,
	"./profileheart.svg": 357,
	"./profileinfo.svg": 355,
	"./profilelocation.svg": 356,
	"./rightarrow.svg": 97,
	"./rightarrowbg.svg": 1017,
	"./rightarrowbgs.svg": 1018,
	"./search.svg": 120,
	"./star.svg": 351,
	"./staractive.svg": 352,
	"./tick.svg": 84,
	"./upload.svg": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1011;